<div class="donations-total-progress-bar">
	<progress max="{{ donationTotals.goal }}" value="{{ donationTotals.total }}" >
	</progress>
</div>
